import React from 'react';
import PropTypes from 'prop-types';
import Spinner from '../../../common/spinner/Spinner.jsx';
import { DATETIME_FORMAT_DATE } from '../../../../utils/helpers/CommonHelper.jsx';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import useTranslateMethod from '../../../../utils/helpers/useTranslateMethod.jsx';
import DataGrid from '../../../common/DataGrid/DataGrid.jsx';
import { useDataGridTextFilter } from '../../../common/DataGrid/filters/useDataGridTextFilter.jsx';
import { useDataGridDateRangeFilter } from '../../../common/DataGrid/filters/useDataGridDateRangeFilter.jsx';
import { RawHtml } from '../../../common/index.jsx';
import { dataGridDateSorter } from '../../../common/DataGrid/sorters/DataGridSorters.jsx';

const AcademicCalendarTable = ({ calendar, onDelete, onEditClick }) => {
  const { t } = useTranslation();

  const eventNameFilterProps = useDataGridTextFilter(
    useTranslateMethod('title_sk', 'title_en'),
  );
  const fromDateFilterProps = useDataGridDateRangeFilter('from');
  const toDateFilterProps = useDataGridDateRangeFilter('to');
  const columns = [
    {
      title: 'Začiatok',
      dataIndex: 'from',
      width: 115,
      defaultSortOrder: 'ascend',
      sorter: dataGridDateSorter('from'),
      render: (from) =>
        from ? dayjs(new Date(from)).format(DATETIME_FORMAT_DATE) : '-',
      ...fromDateFilterProps,
    },
    {
      title: t('Koniec'),
      dataIndex: 'to',
      width: 115,
      sorter: dataGridDateSorter('to'),
      render: (to) =>
        to ? dayjs(new Date(to)).format(DATETIME_FORMAT_DATE) : '-',
      ...toDateFilterProps,
    },
    {
      title: t('Názov'),
      dataIndex: useTranslateMethod('title_sk', 'title_en'),
      render: (title, row) => (
        <>
          <RawHtml>{title}</RawHtml>
          {row.url && (
            <a className="more-info" href={row.url}>
              ...viac info
            </a>
          )}
        </>
      ),
      ...eventNameFilterProps,
    },
  ];

  return !calendar ? (
    <Spinner />
  ) : (
    <>
      <DataGrid
        permissionsBasic={'calendar'}
        uniqueTableId={'academic-calendar-table'}
        dataSource={calendar || []}
        columns={columns}
        rowKey="id"
        className="academic-calendar-table"
        showActionText={false}
        onEditClick={onEditClick}
        onDelete={onDelete}
        pageSize={100}
        scroll={{ x: 500 }}
        rowClassName={(record) => (record.P === 1 ? 'row-highlight-event' : '')}
      />
    </>
  );
};

AcademicCalendarTable.propTypes = {
  calendar: PropTypes.array,
  onDelete: PropTypes.func,
  onEditClick: PropTypes.func,
  onRowClick: PropTypes.func,
};

export default AcademicCalendarTable;
